





















































import {
  Component,
  ComponentConfig,
  RecommendationSettingsBuilder, SectionType,
  Vue
} from "@zoovu/runner-browser-api";
import {AdviceView} from "@zoovu/runner-web-design-base/index";
import {State} from "vuex-class";
import TopProductConfiguration from "@/configuration/customized-top-products-settings";
import {
  RecommendationConfiguration,
  SearchbarConfiguration
} from "@zoovu/runner-web-design-base/src/configuration";

@Component({
  name: "AdviceView",
  mixins: [AdviceView]
})
export default class AdviceViewExtended extends Vue {
  @ComponentConfig(TopProductConfiguration)
  public topProductConfiguration!: TopProductConfiguration;

  @ComponentConfig(RecommendationConfiguration)
  configuration: RecommendationConfiguration;

  @ComponentConfig(SearchbarConfiguration)
  searchbarConfiguration: SearchbarConfiguration;

  @State
  showPagination!: boolean;

  public showSortComponent = false;

  public showClusterHeaders = false;

  setVisualSettings(): void {
    const recommendationSettingsBuilder = new RecommendationSettingsBuilder()
      .withNumberOfProductsForSection(SectionType.QUESTIONNAIRE, {
        numberOfProductsPerPage: this.configuration.numberOfProductsPerQuestionnairePage,
        numberOfTopProductsPerPage: this.resolveTopProductsNumber(SectionType.QUESTIONNAIRE),
        isQueryVisible: this.searchbarConfiguration?.showOnQuestionnaireSection ?? false,
      })
      .withNumberOfProductsForSection(SectionType.RESULTS_PAGE, {
        numberOfProductsPerPage: this.configuration.numberOfProductsPerResultsPage,
        numberOfTopProductsPerPage: this.resolveTopProductsNumber(SectionType.RESULTS_PAGE),
        isQueryVisible: this.searchbarConfiguration?.showOnResultsSection ?? false,
      });

    if (!this.configuration.showInitialRecommendation) {
      recommendationSettingsBuilder.withInitialRecommendationDisabled();
    }

    this.advice.setRecommendationSettings(recommendationSettingsBuilder.build());
  }
}
